import { getConversationSourceChannel, sourceTypeChannels, type ConnectorChannel } from "#features/conversations/types/channels.tsx";
import type { ConversationSource } from "#types/types.ts";

// Source types the frontend has not been regenerated for yet are dropped rather than
// shown as a neutral icon, so the aggregated row never carries a meaningless pill.
// Deduped on nameKey rather than on channel identity: distinct channels can carry the same
// label and icon (org vs. personal Teams), and consumers key the rendered pills on nameKey.
export const getConversationSourceChannels = (sources: ConversationSource[]): ConnectorChannel[] => {
    const channelsByNameKey = new Map<string, ConnectorChannel>();

    for (const source of sources) {
        if (!(source.sourceType in sourceTypeChannels)) {
            continue;
        }

        const channel = getConversationSourceChannel(source);

        if (!channelsByNameKey.has(channel.nameKey)) {
            channelsByNameKey.set(channel.nameKey, channel);
        }
    }

    return Array.from(channelsByNameKey.values());
};
